<template>
    <div class="system-health fts-table-wrapper">
        <div class="card-body">
            <div class="system-health-content">
                <div class="bookmarks-and-control">
                    <div class="bookmarks">
                        <div :class="['bookmark', bookmark == 1 ? 'selected' : '']" @click="selectBookmark(1)">Issues Found <span v-if="bookmark == 1">({{summaryCount}})</span></div>
                        <div :class="['bookmark', bookmark == 2 ? 'selected' : '']" @click="selectBookmark(2)">Resolved <span v-if="bookmark == 2">({{summaryCount}})</span></div>
                    </div>
                    <div class="controls">
                        <a v-if="anythingSelected" class="control" @click="unselectAll()">Unselect All</a>
                        <a v-else class="control" @click="selectAll()">Select All</a>
                        <a v-if="listVisible" class="control" @click="hideList()">Hide List</a>
                        <a v-else class="control" @click="showList()">Show List</a>
                    </div>
                </div>
                <div class="categories">
                    <div v-for="type of summaryBoxes" class="category">
                        <div @click="clickAtHeader(type)" :class="['category-content', isAllSelected(type) ? 'selected' : '']">
                            <h3>{{type.groupName}} ({{type.amount}})</h3>
                            <div class="time-row">
                                <i class="fa fa-clock-o"></i>
                                <span>{{type.date}}</span>
                            </div>
                        </div>
                        <div :class="['category-types', listVisible ? 'visible' : '']">
                            <div v-for="subtype of type.types" class="type">
                                <FTScheckbox @change.native="clickAtFilter()" v-model="subtype.selected" :label="subtype.type + ' (' + subtype.amount + ')'"></FTScheckbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-row">
                    <div class="left-side">
                        <div class="search-box">
                            <b-form-group>
                                <b-input-group>
                                    <input type="text" class="form-control"  v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search issue" />
                                </b-input-group>
                            </b-form-group>
                        </div>
                        <div class="companies-select">
                            <div class="fts-dropdown" v-click-outside="closeDropdownCompany">
                                <div :class="['dropdown-control', openedDropdownCompany ? 'straight-border' : '']" @click="openCloseDropdownCompany">
                                    <span class="dropdown-title" v-if="selectedCompanies.length == 0">Companies</span>
                                    <div v-else class="selected-list">
                                        <div v-for="selected in displaySelectedCompanies" class="selected-item">
                                            {{selected.label}}
                                            <i class="fa fa-times-circle" @click.stop="deselectOptionCompanies(selected)"></i>
                                        </div>
                                    </div>
                                    <span class="count-hidden">
                                        {{countHiddenCompanies}}
                                    </span>
                                    <i :class="['fa', openedDropdownCompany ? 'fa-caret-up' : 'fa-caret-down']"></i>
                                </div>
                                <div :class="['dropdown-list', openedDropdownCompany ? 'list-visible' : '']">
                                    <div class="dropdown-search">
                                        <i class="fa fa-search"></i>
                                        <input v-model="searchedPhraseCompany" type="text" placeholder="Search" @keyup="searchPhraseCompanies"/>
                                    </div>
                                    <div class="dropdown-options">
                                        <div class="dropdown-option">
                                            <label class="dropdown-label" :for="'company-option0'" :option-selected="isAllRowSelected()">
                                                <input class="dropdown-checkbox" :id="'company-option0'" type="checkbox" :checked="isAllRowSelected()" @change="selectAllOptionCompany()">
                                                <span></span>
                                                <span class="option-content">Select All Companies</span>
                                            </label>
                                        </div>
                                        <div class="dropdown-option" v-for="row in displayedCompanies">
                                            <label class="dropdown-label" :for="'company-option' + row.value" :option-selected="row.selected">
                                                <input class="dropdown-checkbox" :id="'company-option' + row.value" type="checkbox" :checked="row.selected" @change="selectOptionCompany(row)">
                                                <span></span>
                                                <span class="option-content">{{row.label}}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="clear-box">
                                        <button class="btn btn-light clear-btn" @click="clearCompaniesDropdown">Clear</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="size-page-wrapper text-right">
                        <div class="export-control">
                            <label for="export-setting">Export:</label>
                            <select v-model="exportMode" id="export-setting" class="form-control export-dropdown custom-select">
                                <option value="1">Current Page</option>
                                <option value="2">All pages</option>
                            </select>
                            <button id="simManagementExport" class="btn btn-primary" v-on:click="openExportModal()">Export</button>
                        </div>
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div :class="['fts-table', 'table-responsive-sm', noData == true ? 'min-height' : '']">
                    <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment fts-table system-health-table">
                        <thead>
                            <tr>
                                <th @click="changeSort(1)" :aria-sort="setAreaSort(1)">First Occured</th>
                                <th @click="changeSort(2)" :aria-sort="setAreaSort(2)">Type</th>
                                <th @click="changeSort(3)" :aria-sort="setAreaSort(3)">Company</th>
                                <th v-if="bookmark == 2" @click="changeSort(4)" :aria-sort="setAreaSort(4)">Resolved at</th>
                                <th>Description</th>
                                <th>Source Type</th>
                                <th class="issue-source-header">Issue Source</th>
                                <th>Expected Data</th>
                                <th>Actual Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="issue of issuesList" :key="'issue-id-' + issue.id">
                                <td class="date-cell">{{issue.firstOccurred}}</td>
                                <td>{{issue.type}}</td>
                                <td>{{issue.companyName}}</td>
                                <td v-if="bookmark == 2">{{issue.resolvedAt}}</td>
                                <td>{{issue.description}}</td>
                                <td>{{issue.issueSourceType}}</td>
                                <td class="issue-source-cell">
                                    <span class="issue-source-text">{{issue.issueSource}} <i class="fa fa-copy" @click="copySource(issue.issueSource)"></i></span>
                                </td>
                                <td>{{issue.expectedData}}</td>
                                <td>{{issue.actualData}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="fts-bottom-table fts-bottom-table-centered system-health-table-nav">
                        <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                            <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                        </nav>
                    </div>

                    <div class="no-data" v-if="loading == false && noData == true">
                        <div class="text">
                            No issues to display
                        </div>
                    </div>
                </div>
                <div class="loader" v-if="loading && noData == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>

                    <div class="text">
                        Issues are being loaded...
                    </div>
                </div>
            </div>
        </div>
        <b-modal size="md" ref="selectExportFormat" id="selectExportFormat" centered hide-header hide-footer>
            <i class="fa fa-close" @click="closeExportModal"></i>
            <img src="../../assets/img/file-format.svg">
            <h3>Save export file as:</h3>
            <div>
                <button class="btn btn-primary csv" v-on:click="exportCsv()">CSV</button>
                <button class="btn btn-primary xls" v-on:click="exportXlsx()">XLSX</button>
            </div>
            <button class="btn btn-light" @click="closeExportModal()">Cancel</button>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Axios from "axios";
    import globalStore from "../../variables";
    import Paginate from "vuejs-paginate";
    import VueClipboard from 'vue-clipboard2'
    import FTScheckbox from "../../ftsComponents/FTScheckbox";

    Vue.use(VueClipboard)

    export default {
        name: "SystemHealth",
        components: {
            FTScheckbox,
            Paginate
        },
        data() {
            return {
                sortSettings: {
                    page: 1,
                    size: 40,
                    desc: true,
                    sort: 1
                },
                filter: '',
                searchString: '',
                bookmark: 1,
                summaryCount: 0,
                typingTimer: null,
                loading: false,
                noData: false,
                systemHealthTypes: [],
                summaryBoxes: [],
                exportMode: 1,
                openedDropdownCompany: false,
                searchedPhraseCompany: '',
                displaySelectedCompanies: [],
                selectedCompanies: [],
                countHiddenCompanies: '',
                displayedCompanies: [],
                selected: {
                    companies: 0
                },
                issuesList: [],
                paginationCount: false,
                listVisible: true,
                anythingSelected: false
            }
        },
        methods: {
            getPagination() {
                let companies = ''
                if (this.selectedCompanies.length > 0) {
                    for (let company of this.selectedCompanies) {
                        companies += '&companyId=' + company.value
                    }
                }
                let types = ''
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        if (subtype.selected) {
                            types += '&type=' + subtype.typeCode
                        }
                    }
                }

                let resolved = ''
                if (this.bookmark == 1) {
                    resolved = '&resolved=false'
                } else {
                    resolved = '&resolved=true'
                }

                Axios.get(globalStore.data.restApiUrl + '/system-health/page-count?size=' + this.sortSettings.size + this.searchString + companies + types + resolved)
                    .then(response => {
                        this.paginationCount = response.data;
                    })
            },
            getIssuesList(resetPage) {
                this.loading = true
                this.noData = false
                if (resetPage) {
                    this.sortSettings.page = 1
                    this.getPagination();
                }
                let companies = ''
                if (this.selectedCompanies.length > 0) {
                    for (let company of this.selectedCompanies) {
                        companies += '&companyId=' + company.value
                    }
                }
                let types = ''
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        if (subtype.selected) {
                            types += '&type=' + subtype.typeCode
                        }
                    }
                }

                let resolved = ''
                if (this.bookmark == 1) {
                    resolved = '&resolved=false'
                } else {
                    resolved = '&resolved=true'
                }
                Axios.get(globalStore.data.restApiUrl + '/system-health/list?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + companies + types + resolved)
                    .then(response => {
                        this.issuesList = response.data
                        if (this.issuesList.length > 0) {
                            this.noData = false
                        } else {
                            this.noData = true
                        }
                        this.loading = false
                        setTimeout(() => {this.checkIssueWidth()}, 100)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            checkIssueWidth () {
                let cells = Array.from(document.querySelectorAll('.issue-source-cell .issue-source-text')).forEach(cell => {
                    if (cell.offsetWidth > 300) {
                        cell.parentElement.classList.add('overflowed')
                        if (cell.offsetWidth > 600) {
                            cell.classList.add('min-600')
                        }
                    }
                })
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                this.getIssuesList(false);
            },
            sizePage() {
                this.getIssuesList(true);
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getIssuesList(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            isAnyFilterChecked() {
                let ret = 0
                for (let filter of this.summaryBoxes) {
                    if (filter.selected) {
                        ret++
                    }
                }
                if (ret) {
                    ret = true
                } else {
                    ret = false
                }
                return ret
            },
            selectBookmark(id) {
                if (this.bookmark != id) {
                    this.bookmark = id
                    if (id == 1 && this.sortSettings.sort == 4) {
                        this.sortSettings.sort = 1
                    }
                    this.resetSummaryBoxes()
                    this.getHealthCheckInfo()
                    this.getIssuesList(true)
                }
            },
            hideList() {
                if (this.listVisible) {
                    this.listVisible = false
                }
            },
            showList() {
                if (!this.listVisible) {
                    this.listVisible = true
                }
            },
            isAllSelected(type) {
                let count = 0
                for (let item of type.types) {
                    if (item.selected) {
                        count++
                    }
                }
                let result
                if (count == type.types.length) {
                    result = true
                } else {
                    result == false
                }
                return result
            },
            selectAll() {
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        subtype.selected = true
                    }
                }
                this.anythingSelected = true
                this.getIssuesList(true)
            },
            unselectAll() {
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        subtype.selected = false
                    }
                }
                this.anythingSelected = false
                this.getIssuesList(true)
            },
            checkIfAllSelected() {
                let anythingSelected = false
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        if (subtype.selected) {
                            anythingSelected = true
                            break
                        }
                    }
                this.anythingSelected = anythingSelected
            }},
            clickAtHeader(type) {
                if (this.isAllSelected(type)) {
                    for (let item of type.types) {
                        item.selected = false
                    }
                } else {
                    for (let item of type.types) {
                        item.selected = true
                    }
                }
                this.checkIfAllSelected()
                this.getIssuesList(true)
            },
            clickAtFilter() {
                this.checkIfAllSelected()
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.getIssuesList(true)
                }, 1000)
            },
            openCloseDropdownCompany() {
                if (!this.openedDropdownCompany)
                    this.openedDropdownCompany = true;
                else
                    this.openedDropdownCompany = false;
            },
            closeDropdownCompany() {
                if (this.openedDropdownCompany)
                    this.openedDropdownCompany = false;
            },
            searchPhraseCompanies() {
                if (this.searchedPhraseCompany != '') {
                    this.displayedCompanies = this.companiesList.filter(item => {
                        return item.label.toLowerCase().indexOf(this.searchedPhraseCompany.toLowerCase()) != -1 ? item : null;
                    })
                } else {
                    this.displayedCompanies = this.companiesList;
                }
            },
            selectAllOptionCompany() {
                for (let company in this.displayedCompanies) {
                    this.selectOptionCompany(this.displayedCompanies[company])
                }
            },
            selectOptionCompany(option) {
                clearTimeout(this.typingTimer)
                option.selected = !option.selected;
                if (option.selected)
                    this.selectedCompanies.push(option);
                else
                    this.selectedCompanies = this.selectedCompanies.filter(item => {
                        return option.value != item.value
                    })

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);

                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.getIssuesList(true)
                }, 1000)
            },
            deselectOptionCompanies(option) {
                this.selectedCompanies = this.selectedCompanies.filter(item => {
                    return option.value != item.value
                })
                for (let item of this.companiesList) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }
                for (let item of this.displayedCompanies) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);
            },
            clearCompaniesDropdown() {
                this.companiesList.map(item => {
                    item.selected = false;
                })

                this.displayedCompanies.map(item => {
                    item.selected = false;
                })

                this.selectedCompanies = [];
                this.openedDropdownCompany = false;
                this.selected.companies = 'None selected'
                this.countHiddenCompanies = ''
            },
            isAllRowSelected() {
                if (this.selectedCompanies.length == this.displayedCompanies.length) {
                    return true
                } else {
                    return false;
                }
            },
            showfileFormatPopup() {
                this.$refs['fileFormatModal'].show()
            },
            hidefileFormatPopup() {
                this.$refs['fileFormatModal'].hide()
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow () {
                if (this.filter.length > 0) {
                    this.searchString = '&search=' + escape(this.filter);
                } else {
                    this.searchString = '';
                }
                this.getIssuesList(true)
            },
            getCompaniesList() {
                Axios.get(`${globalStore.data.restApiUrl}/admin/accounts/essentials?page=1&size=1000&sort=2&desc=false`)
                    .then(response => {
                        this.companiesList = [];
                        for (let company of response.data) {
                            this.companiesList.push(
                                {
                                    value: company.companyId,
                                    label: company.companyName,
                                    selected: false
                                }
                            )
                        }
                        this.displayedCompanies = this.companiesList;
                    })
            },
            toTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum;
            },
            convertToAgo(dateParam) {
                let ago = ''
                let now = new Date()
                let date = new Date(dateParam)

                now = this.toTimestamp(now)
                date = this.toTimestamp(date)

                if ((now - date) / 1000 < 60) {
                    ago = Math.floor((now - date) / 1000) + ' seconds ago'
                } else if ((now - date) / 1000 / 60 < 60) {
                    ago = Math.floor((now - date) / 1000 / 60) + ' minutes ago'
                } else if ((now - date) / 1000 / 60 / 60 < 24) {
                    ago = Math.floor((now - date) / 1000 / 60 / 60) + ' hours ago'
                } else if ((now - date) / 1000 / 60 / 60 / 24 / 365 < 1) {
                    ago = Math.floor((now - date) / 1000 / 60 / 60 / 24) + ' days ago'
                } else {
                    ago = Math.floor((now - date) / 1000 / 60 / 60 / 24 / 365) + ' years ago'
                }

                return ago
            },
            resetSummaryBoxes() {
                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        subtype.amount = 0
                        subtype.selected = false
                    }
                }
            },
            getHealthCheckInfo() {
                let resolved = ''
                if (this.bookmark == 1) {
                    resolved = '?resolved=false'
                } else {
                    resolved = '?resolved=true'
                }
                Axios.get(globalStore.data.restApiUrl + '/system-health/last-health-checks-grouped' + resolved)
                    .then(response => {

                        this.summaryCount = 0
                        this.resetSummaryBoxes();
                        let lastCheckDate = response.data[0] && response.data[0].date ? new Date(response.data[0].date) : null

                        this.summaryBoxes = []
                        for (let item of response.data) {
                            let template = {}
                            let lastDate = null
                            template.groupName = item.groupName
                            template.amount = item.groupIssuesAmount
                            this.summaryCount = this.summaryCount + item.groupIssuesAmount
                            template.types = []
                            for (let type of item.types) {
                                if (lastDate == null) {
                                    lastDate = new Date(type.date)
                                } else {
                                    if (lastDate < new Date(type.date)) {
                                        lastDate = new Date(type.date)
                                    }
                                }
                                template.types.push(
                                    {
                                        amount: type.amount,
                                        date: type.date,
                                        type: type.type,
                                        typeCode: type.typeCode,
                                        selected: false
                                    }
                                )
                            }
                            template.date = this.convertToAgo(lastDate)
                            this.summaryBoxes.push(template)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            openExportModal() {
                this.$refs['selectExportFormat'].show()
            },
            closeExportModal() {
                this.$refs['selectExportFormat'].hide()
            },
            exportCsv() {
                this.$refs['selectExportFormat'].hide()

                let mode = ''
                let companies = ''
                if (this.selectedCompanies.length > 0) {
                    for (let company of this.selectedCompanies) {
                        companies += '&companyId=' + company.value
                    }
                }
                let types = ''

                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        if (subtype.selected) {
                            types += '&type=' + subtype.typeCode
                        }
                    }
                }

                let resolved = ''
                if (this.bookmark == 1) {
                    resolved = '&resolved=false'
                } else {
                    resolved = '&resolved=true'
                }
                if (this.exportMode == 1) {
                    mode = '?allResults=false' + '&size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + companies + types + resolved
                } else {
                    mode = '?allResults=true' + this.searchString + companies + types + resolved
                }

                Axios.get(globalStore.data.restApiUrl + "/system-health/csv" + mode)
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'System health.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'System health export went wrong',
                        text: 'Something went wrong during exporting System health data. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['selectExportFormat'].hide()

                let mode = ''
                let companies = ''
                if (this.selectedCompanies.length > 0) {
                    for (let company of this.selectedCompanies) {
                        companies += '&companyId=' + company.value
                    }
                }
                let types = ''

                for (let type of this.summaryBoxes) {
                    for (let subtype of type.types) {
                        if (subtype.selected) {
                            types += '&type=' + subtype.typeCode
                        }
                    }
                }

                let resolved = ''
                if (this.bookmark == 1) {
                    resolved = '&resolved=false'
                } else {
                    resolved = '&resolved=true'
                }
                if (this.exportMode == 1) {
                    mode = '?allResults=false' + '&size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + companies + types + resolved
                } else {
                    mode = '?allResults=true' + this.searchString + companies + types + resolved
                }

                Axios.get(globalStore.data.restApiUrl + "/system-health/xlsx" + mode, {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'System health export.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'System health export went wrong',
                        text: 'Something went wrong during exporting System health data. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            copySource(text) {
                this.$copyText(text)
                    .then( () => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Issue source copied',
                            text: 'Issue source has been copied to your clipboard.',
                            duration: 3000,
                        });
                    })
            }
        },
        mounted() {
            this.getIssuesList(true)
            this.getCompaniesList();
            this.getHealthCheckInfo();
        }
    }
</script>

<style lang="scss">
    .system-health {
        background-color: #f5f5f5;
        border: 1px solid #cfd2d5;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        .card-body {
            padding: 0;
        }
        .system-health-content {
            position: relative;
            background-color: #fff;
            .bookmarks-and-control {
                display: flex;
                justify-content: space-between;
                padding-right: 20px;
                .bookmarks {
                    display: flex;

                    .bookmark {
                        width: 180px;
                        padding: 20px 0;
                        text-align: center;
                        text-transform: uppercase;
                        cursor: pointer;
                        font-weight: 700;

                        span {
                            display: none;
                        }

                        &.selected {
                            margin-bottom: -1px;
                            color: #0088FF;
                            border-top-left-radius: 8px;
                            border-top-right-radius: 8px;
                            -webkit-box-shadow: 0px 0px 0px 1px #C9CFD4;
                            box-shadow: 0px 0px 0px 1px #C9CFD4;
                            border-bottom: 1px solid #fff;

                            span {
                                display: initial;
                            }
                        }
                    }
                }
                .controls {
                    display: flex;
                    align-items: center;
                    .control {
                        margin-right: 30px;
                        color: #0088ff;
                        text-transform: uppercase;
                        font-weight: 700;
                        cursor: pointer;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
            .categories {
                display: flex;
                border-top: 1px solid #c9cfd4;
                border-bottom: 1px solid #c9cfd4;
                background-color: #f3f3f3;
                .category {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    max-width: calc(100% / 6);
                    min-width: 150px;
                    border-right: 2px solid #fff;
                    background-color: #f8f8f8;
                    cursor: pointer;
                    &:last-child {
                        border-right: 0;
                    }
                    .category-content {
                        display: flex;
                        flex-direction: column;
                        padding: 12px 24px 12px;
                        background-color: #f3f3f3;
                        h3 {
                            margin: 0 0 5px;
                            font-size: 14px;
                            font-weight: 400;
                        }
                        .time-row {
                            font-size: 12px;
                            color: #515B65;
                            .fa-clock-o {
                                margin: 0 8px 0 0;
                            }
                        }
                        &.selected {
                            background-color: #0088ff;
                            h3,
                            .time-row {
                                color: #fff;
                            }
                        }
                    }

                    .category-types {
                        display: none;
                        padding: 18px 24px 12px;
                        &.visible {
                            display: initial;
                        }
                    }

                    &.selected {
                        background-color: #0088ff;
                        color: #fff;
                        .category-content {
                            .time-row {
                                color: #fff;
                            }
                        }
                    }
                }
            }
            .filter-row {
                padding: 20px;
                .left-side {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .companies-select {
                        margin-left: 20px;
                    }
                }
                .text-right {
                    .export-control {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        align-content: center;

                        label[for="export-setting"] {
                            margin-top: 0;
                        }

                        .custom-select {
                            min-width: 180px;
                        }

                        .btn-primary {
                            padding-left: 10px;
                            padding-right: 10px;
                            text-align: center;
                            margin-left: 15px;
                            margin-right: 30px;
                        }
                    }
                }
            }
            .fts-table {
                position: relative;
                &.min-height {
                    min-height: 300px;
                }
                .system-health-table-nav {
                    bottom: initial;
                }
                .issue-source-cell {
                    max-width: 300px;
                    .issue-source-text {
                        white-space: nowrap;
                    }

                    &.overflowed {
                        position: relative;
                        overflow: hidden;
                        white-space: nowrap;
                        &:after {
                            content: '...';
                            position: absolute;
                            right: 0;
                            padding: 0 12px;
                            background: inherit;
                            z-index: 100;
                        }
                        &:hover {
                            overflow: visible;
                            &:after {
                                content: none;
                            }
                            .issue-source-text {
                                position: relative;
                                max-width: 600px;
                                padding: 10px 16px;
                                border: 1px solid #fff;
                                -webkit-border-radius: 3px;
                                -moz-border-radius: 3px;
                                border-radius: 3px;
                                background-color: #0088ff;
                                white-space: nowrap;
                                z-index: 90;
                                &.min-600 {
                                    display: block;
                                    min-width: 600px;
                                    white-space: initial;
                                }
                            }
                        }
                    }

                }
                .date-cell {
                    white-space: nowrap;
                }
                .no-data {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
            }
            .loader {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                background-color: rgba(255, 255, 255, 0.7);

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                align-content: center;

                .sk-wave {
                    height: 60px;
                    .sk-rect {
                        width: 3px;
                        background-color: #39c354;
                        border-radius: 4px;
                    }
                }

                .text {
                    margin-top: 20px;
                    text-align: center;
                    font-size: 15px;
                    font-weight: 700;
                }
            }
        }
    }


    #selectExportFormat___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        i {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 16px;
            cursor: pointer;
        }

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }
    }

    .dark-theme {
        .system-health {
            border-color: #1a1c1d;
            background-color: #383e45;
            color: #fff;
            .card-body {
                background-color: #383e45;
            }
            .system-health-content {
                background-color: #3a4149;
                border-color: #1a1c1d;
                .bookmarks {
                    .bookmark {
                        &.selected {
                            box-shadow: 0px 0px 0px 1px #1a1c1d;
                            border-bottom: 1px solid #3a4149;
                        }
                    }
                }
                .categories {
                    border-color: #1a1c1d;
                    background-color: #383e45;
                    .category {
                        background-color: #383e45;
                        border-color: #1a1c1d;
                        &.selected {
                            background-color: #0088ff;
                        }
                        .category-content {
                            background-color: #2f353a;
                            .time-row {
                                color: #fff;
                            }
                        }
                    }
                }
                .filter-row {
                    .form-control {
                        &::placeholder {
                            color: #fff;
                        }
                    }
                    .fts-dropdown {
                        background-color: #515b65;
                    }
                    .custom-select {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #fff;
                    }
                }
                .fts-table {
                    .no-data {
                        background-color: rgba(0, 0, 0, 0.4);
                    }
                }
                .loader {
                    background-color: rgba(0, 0, 0, 0.4);
                }
            }
        }
    }
</style>
